import React from 'react';
import { useEditorSessionObserver } from '../EditorSession';
import { Selection } from '../Selection';
import { ActiveSelectionContextMenu } from './ActiveSelectionContextMenu';
import { ContextMenuProps } from './ContextMenuProps';
import { EmptySelectionContextMenu } from './EmptySelectionContextMenu';

export const ContextMenuSelector = React.memo((props: ContextMenuProps) => {
    const selection = useEditorSessionObserver(Selection);
    return !!selection.size
        ? <ActiveSelectionContextMenu {...props} />
        : <EmptySelectionContextMenu {...props} />;
});
